module.exports = __webpack_public_path__ + "img/RoutingNetwork_White.9ddc95ae.svg";